module.exports = __webpack_public_path__ + "img/santander-logo.acc9f942.svg";